module.exports = __webpack_public_path__ + "media/images/fb-icon-e997ee2d.png";